import { render } from "./storeSocialLinks.vue?vue&type=template&id=e1b52828&scoped=true"
import script from "./storeSocialLinks.vue?vue&type=script&lang=js"
export * from "./storeSocialLinks.vue?vue&type=script&lang=js"

import "./storeSocialLinks.vue?vue&type=style&index=0&id=e1b52828&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1b52828"]])

export default __exports__